'use client';

/**
 * Cookie preferences panel (GitLab #649).
 *
 * Presentational and fully controlled: it renders the categories an
 * organisation has configured, a toggle for each optional one and the
 * disclosed cookie table beneath it (AC4/AC11). It owns no consent state,
 * so the gate and any future standalone preferences page can share it and
 * the compliance logic stays in `ConsentProvider`.
 */
import { c as _c } from "react/compiler-runtime";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Switch } from '@/components/ui/switch';
import { cn } from '@/lib/utils';
import type { ConsentCategories } from '@/lib/analytics/consentCookie';
import type { CookieCategory, CookieCategoryConfig } from '@/types/organization';
export interface CookiePreferencesProps {
  /** Categories to render, in the order the organisation configured them. */
  categories: CookieCategoryConfig[];
  /** Current draft choice. */
  value: ConsentCategories;
  /** Called when an optional category is toggled. */
  onChange: (category: CookieCategory, granted: boolean) => void;
  /** Distinguishes ids when more than one panel is on the page. */
  idPrefix?: string;
  className?: string;
}
export function CookiePreferences(t0) {
  const $ = _c(20);
  const {
    categories,
    value,
    onChange,
    idPrefix: t1,
    className
  } = t0;
  const idPrefix = t1 === undefined ? "cookie-category" : t1;
  let T0;
  let t2;
  let t3;
  let t4;
  if ($[0] !== categories || $[1] !== className || $[2] !== idPrefix || $[3] !== onChange || $[4] !== value) {
    const visible = categories.filter(_temp);
    T0 = Accordion;
    t2 = "multiple";
    if ($[9] !== className) {
      t3 = cn("space-y-2", className);
      $[9] = className;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    let t5;
    if ($[11] !== idPrefix || $[12] !== onChange || $[13] !== value) {
      t5 = config_0 => {
        const isLocked = config_0.category === "necessary" || config_0.required;
        const switchId = `${idPrefix}-${config_0.category}`;
        const labelId = `${switchId}-label`;
        return <AccordionItem key={config_0.category} value={config_0.category}><div className="flex items-center gap-2 pr-4"><AccordionTrigger value={config_0.category} className="flex-1 text-left"><span id={labelId} className="font-medium">{config_0.label}</span></AccordionTrigger>{isLocked ? <span className="shrink-0 text-xs text-muted-foreground">Always on</span> : null}<Switch id={switchId} aria-labelledby={labelId} checked={isLocked ? true : value[config_0.category]} disabled={isLocked} onCheckedChange={checked => onChange(config_0.category, checked)} /></div><AccordionContent value={config_0.category}><p className="text-sm text-muted-foreground">{config_0.description}</p>{config_0.cookies.length > 0 ? <div className="mt-3 overflow-x-auto" tabIndex={0} role="region" aria-label={`Cookies used under ${config_0.label}`}><table className="w-full text-left text-xs"><caption className="sr-only">Cookies used under {config_0.label}</caption><thead><tr className="text-muted-foreground"><th scope="col" className="py-1 pr-3 font-medium">Cookie</th><th scope="col" className="py-1 pr-3 font-medium">Provider</th><th scope="col" className="py-1 pr-3 font-medium">Purpose</th><th scope="col" className="py-1 font-medium">Expires</th></tr></thead><tbody>{config_0.cookies.map(_temp2)}</tbody></table></div> : <p className="mt-3 text-xs text-muted-foreground">No cookies are currently used for this purpose.</p>}</AccordionContent></AccordionItem>;
      };
      $[11] = idPrefix;
      $[12] = onChange;
      $[13] = value;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    t4 = visible.map(t5);
    $[0] = categories;
    $[1] = className;
    $[2] = idPrefix;
    $[3] = onChange;
    $[4] = value;
    $[5] = T0;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    T0 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  let t5;
  if ($[15] !== T0 || $[16] !== t2 || $[17] !== t3 || $[18] !== t4) {
    t5 = <T0 type={t2} className={t3}>{t4}</T0>;
    $[15] = T0;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
}
function _temp2(cookie) {
  return <tr key={cookie.name} className="border-t align-top"><td className="py-1.5 pr-3 font-mono break-all">{cookie.name}</td><td className="py-1.5 pr-3">{cookie.provider}</td><td className="py-1.5 pr-3">{cookie.purpose}</td><td className="py-1.5">{cookie.duration}</td></tr>;
}
function _temp(config) {
  return config.category === "necessary" || config.required || config.cookies.length > 0;
}